import Navbar from "../components/navbar"
import { useState, useRef } from "react"
import { FaBars } from "react-icons/fa"
import { Dropdown, Space, Menu } from 'antd';
import { Link } from "react-router-dom";
import { CgChevronDownO } from "react-icons/cg"
import { locations } from "../components/locations"
import { Select, Tag } from "antd"
import { AiOutlineInfoCircle, AiOutlineClockCircle } from "react-icons/ai"
import { BsLightningFill } from "react-icons/bs"
import { FaFilter } from "react-icons/fa"
import { Drawer } from "antd";
import { AiOutlineHeart } from "react-icons/ai"
import { MdOutlineCardTravel } from "react-icons/md"
import { CiStethoscope } from "react-icons/ci"
import { BiPlusMedical } from "react-icons/bi"
import { FiUsers } from "react-icons/fi"
import { ImPower } from "react-icons/im"
import { AiOutlineStar } from "react-icons/ai"
import { RxCross2 } from "react-icons/rx"
import { BsCalendar2Check } from "react-icons/bs"
import { BsFillShareFill } from "react-icons/bs"
import { FaThumbsUp } from "react-icons/fa"
import Footer from "../components/footer"
import { BsBoxArrowUpRight } from "react-icons/bs"

const SearchJobsPage = () => {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const [locationOptions, setLocationOptions] = useState(locations)
    const [locationSearch, setLocationSearch] = useState(locationOptions[0])
    const [specialityOptions, setSpecialityOptions] = useState(["Accute Care Float", "Trauma ICU", "Urgent Care", "Utilization Review", "Vaccination Review", "Wound Care", "Transplant"])
    const [specialitySearch, setSpecialitySearch] = useState(specialityOptions[0])
    const [isLowerAcuity, setIsLowerAcuity] = useState(false)
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    let relatedSpecialityTags = [
        {
            tag: "abc",
            key: 1
        },
        {
            tag: "abc",
            key: 2
        },
        {
            tag: "abc",
            key: 3
        },
        {
            tag: "abc",
            key: 4
        },
        {
            tag: "abc",
            key: 5
        },
        {
            tag: "abc",
            key: 6
        },
        {
            tag: "abc",
            key: 7
        },
        {
            tag: "abc",
            key: 8
        },
    ]

    let lowerAcuityTags = [
        {
            tag: "abc",
            key: 1
        },
        {
            tag: "abc",
            key: 2
        },
        {
            tag: "abc",
            key: 3
        },
        {
            tag: "abc",
            key: 4
        },
        {
            tag: "abc",
            key: 5
        },
        {
            tag: "abc",
            key: 6
        },
        {
            tag: "abc",
            key: 7
        },
        {
            tag: "abc",
            key: 8
        },
    ]
    const { Option } = Select;

    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }

    const tagCloseSpeciality = (key) => {
        let index = relatedSpecialityTags.findIndex(item => item.key == key)
        relatedSpecialityTags.splice(index, 1)
        console.log(relatedSpecialityTags)
    }

    const tagCloseAcuity = (key) => {
        let index = relatedSpecialityTags.findIndex(item => item.key == key)
        lowerAcuityTags.splice(index, 1)
        console.log(relatedSpecialityTags)
    }

    const LocationDrpdownDiv = (
        <Menu>
            <div className="w-[300px] md:w-[420px] p-3">
                <h1 className="font-semibold text-xs mb-2">Filter by location</h1>
                <Select
                    mode="multiple"
                    style={{
                        width: '100%',
                    }}
                    placeholder="City or State"
                    // defaultValue={locationSearch}
                    optionLabelProp="label"
                    value={locationSearch}
                    onChange={(e) => setLocationSearch(e)}
                >

                    {
                        locationOptions?.map((val, i) => {
                            return (
                                <Option key={i} value={val} label={val}>
                                    <Space>
                                        {val}
                                    </Space>
                                </Option>
                            )
                        })
                    }
                </Select>
                <div className="bg-gray-200 p-3 mt-3">
                    <div className="flex items-center gap-x-2">
                        <input type="checkbox" name="" id="" />
                        <label htmlFor="">Compact License States</label>
                    </div>
                    <div>
                        <div className="flex items-center gap-x-2">
                            <input type="checkbox" name="" id="" />
                            <label htmlFor="">Quick License States</label>
                        </div>
                        <span className="font-semibold text-[12px]">Application process 2 weeks or less!</span>
                    </div>
                    <div className="flex justify-between gap-x-2 mt-2">
                        <AiOutlineInfoCircle className="text-[50px]" />
                        <p className="text-[12px]">
                            Many jobs don’t require a license in hand to apply. Your recruiter can
                            help plan for your ideal locations. We'll get you licensed quickly!
                        </p>
                    </div>
                </div>
                <button className="bg-cyan-400 px-3 py-1 font-semibold rounded-full mt-2">SHOW RESULTS</button>
            </div>
        </Menu>
    )

    const specialitiesDrpdownDiv = (
        <Menu>
            <div className="w-[300px] md:w-[420px] p-3">
                <h1 className="font-semibold text-xs mb-2">Filter by Specialities</h1>
                <p className="text-[12px]">
                    You'll see specialties based on your profession of <a href="#" className="font-semibold">Registered Nurse Change</a>
                </p>
                <div className="mt-3">
                    <h1 className="font-semibold">Your specialities</h1>
                    <Select
                        mode="multiple"
                        style={{
                            width: '100%',
                        }}
                        placeholder="Specialities"
                        optionLabelProp="label"
                        value={specialitySearch}
                        onChange={(e) => setSpecialitySearch(e)}
                    >

                        {
                            specialityOptions?.map((val, i) => {
                                return (
                                    <Option key={i} value={val} label={val}>
                                        <Space>
                                            {val}
                                        </Space>
                                    </Option>
                                )
                            })
                        }
                    </Select>
                </div>

                <div>
                    {relatedSpecialityTags.length > 0 && <h2>Related Specialities</h2>}
                    <div className="p-2">
                        {
                            relatedSpecialityTags?.map((val, index) => {
                                return (
                                    <Tag key={index} closable onClose={() => tagCloseSpeciality(val.key)}>
                                        {
                                            val.tag
                                        }
                                    </Tag>
                                )
                            })
                        }
                    </div>
                </div>

                <div>
                    <div className="flex gap-x-2 items-center">
                        <input onChange={() => setIsLowerAcuity(!isLowerAcuity)} id="lower_aquity" type="checkbox" name="lower acuity specialities" />
                        <label htmlFor="lower_aquity">Include lower acuity specialties</label>
                    </div>
                    <div className="font-semibold mt-1">
                        {isLowerAcuity && <h1 className="mb-2">Lower Acuity</h1>}
                        <div className="flex gap-1 flex-wrap ">
                            {
                                isLowerAcuity &&
                                lowerAcuityTags?.map((val, index) => {
                                    return (
                                        <Tag key={index} closable onClose={() => tagCloseAcuity(val.key)}>
                                            {
                                                val.tag
                                            }
                                        </Tag>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>


                <button className="bg-cyan-400 px-3 py-1 font-semibold rounded-full mt-4 text-gray-700">SHOW RESULTS</button>
            </div>
        </Menu>
    )

    const shiftContractDrpdownDiv = (
        <Menu>
            <div className="w-[300px] md:w-[420px] lg:w-[700px] p-3">
                <h1 className="font-semibold text-gray-600">Filter by Shifts & Contract</h1>
                <div className="flex flex-col gap-y-3">
                    <div className="flex items-center gap-x-2">
                        <div className="text-[#608d96] w-[100px]">
                            Employment Type
                        </div>
                        <div className="flex gap-2 items-center flex-wrap">
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                Travel
                            </label>
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                Per Diem
                            </label>
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                Permanent
                            </label>
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                Workforce Disruption
                            </label>
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                Interim Leadership
                            </label>
                        </div>
                    </div>
                    <div className="flex items-center gap-x-2">
                        <div className="text-[#608d96] w-[100px]">
                            Contract Length <br />
                            (in weeks)
                        </div>
                        <div className="flex gap-2 items-center flex-wrap">
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                1 to 2 (Rapid Response)
                            </label>
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                3 to 6
                            </label>
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                7 to 10
                            </label>
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                11 to 16
                            </label>
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                17+
                            </label>
                        </div>
                    </div>
                    <div className="flex items-center gap-x-2">
                        <div className="text-[#608d96] w-[100px]">
                            Shift
                        </div>
                        <div className="flex gap-2 items-center flex-wrap">
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                3x12
                            </label>
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                4x10
                            </label>
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                4x12
                            </label>
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                5x8
                            </label>
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                5x12
                            </label>
                        </div>
                    </div>
                    <div className="flex items-center gap-x-2">
                        <div className="text-[#608d96] w-[100px]">
                            Time of Day
                        </div>
                        <div className="flex gap-2 items-center flex-wrap">
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                Day
                            </label>
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                Mid
                            </label>
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                Night
                            </label>
                        </div>
                    </div>
                    <div className="flex items-center gap-x-2">
                        <div className="w-[100px]">
                        </div>
                        <div className="flex gap-2 items-center flex-wrap">
                            <label className="flex gap-x-1 items-center">
                                <input type="checkbox" />
                                Exclude Alternating Shifts
                            </label>
                        </div>
                    </div>
                    <div>
                        <button className="bg-cyan-400 px-3 py-1 font-semibold rounded-full mt-2">SHOW RESULTS</button>
                    </div>
                </div>
            </div>
        </Menu>
    )

    const savedSearchesDropdown = (
        <Menu>
            <div className="px-3 py-4">
                <div className="text-sm">
                    <p>
                        You haven't saved any searches yet!
                    </p>
                    <p>
                        Click "Save This Search" to save searches based on your search criteria and setup email alerts for new jobs that match.
                    </p>
                </div>
                <div>
                    <button className="rounded-full hover:bg-gray-200 px-2 py-1">
                        <Link to={"/prefences"} className="!text-[11px] hover:text-cyan-700 underline font-medium uppercase hover:underline text-cyan-700">
                            Manage alerts
                        </Link>
                    </button>
                </div>
            </div>
        </Menu>
    )

    return (
        <Navbar active={"jobs"} navShow={navShown}>
            <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                    X
                </span>
                <h1 className="text-center text-white py-4 w-full">Search Jobs</h1>
            </div>
            <div className="relative top-14">
                <div className="flex flex-col lg:flex-row items-center px-3 py-1 border-b border-gray-700">
                    <div className="lg:w-1/2 w-full">
                        <div className="flex items-center cursor-pointer" onClick={() => setIsDrawerOpen(true)}>
                            <span className="underline text-gray-700">Filters</span>
                            <FaFilter />
                        </div>
                    </div>
                    <div className="lg:w-1/2 w-full flex items-center justify-between gap-x-3">
                        <div className="flex items-center gap-x-2">
                            <input type="checkbox" name="crisis_response" id="crisis_response" />
                            <label htmlFor="crisis_response" className="flex items-center md:gap-x-1 text-xs">
                                Crisis Response
                                <span className="w-[25px] h-[25px] flex items-center justify-center rounded-full bg-red-600">
                                    <BsLightningFill className="text-white text-[10px]" />
                                </span>
                            </label>
                        </div>
                        <div className="flex items-center gap-x-2">
                            <div className="flex items-center gap-x-1">
                                <AiOutlineHeart className="text-[30px] md:text-[20px]" />
                                <span className="capitalize text-cyan-600 text-xs">
                                    Save this search
                                </span>
                            </div>
                            <Dropdown
                                className="cursor-pointer"
                                overlay={savedSearchesDropdown}
                            >
                                <button className="flex items-center gap-x-1 border p-1 border-gray-400 rounded text-gray-500 text-xs">
                                    My Saved Searches
                                    <CgChevronDownO className="text-xl" />
                                </button>
                            </Dropdown>
                        </div>
                    </div>
                </div>

                {/* Content Div  */}

                <div className="flex bg-gray-100 !h-[80vh] flex-col lg:flex-row">
                    <div className="lg:w-1/2 border-r border-gray-300">
                        <div className="flex justify-between p-2">
                            <div>
                                <span className="block font-semibold">
                                    1,693 Openings
                                </span>
                                <span className="block">
                                    (1,072 Unique Jobs)
                                </span>
                            </div>
                            <select name="" id="" className="border-0 border-b bg-transparent">
                                <option value="Featured">Featured</option>
                                <option value="high-to-low">Pay (High to Low)</option>
                                <option value="bonus">Bonus Available</option>
                            </select>
                        </div>

                        <div className="flex flex-col w-full px-2 gap-y-3 overflow-y-scroll h-[70vh] pb-10">
                            <div className="bg-white p-3 rounded-lg border-cyan-400 border">
                                <div className="flex flex-col gap-y-1">
                                    <div className="flex gap-x-1 items-center">
                                        <span className="h-5 w-5 flex justify-center rounded-full items-center bg-red-600">
                                            <ImPower className="text-white text-sm" />
                                        </span>
                                        <span className="text-red-600 font-semibold">Crisis response
                                        </span>
                                    </div>
                                    <div className="flex items-start gap-x-2">
                                        <div>
                                            <img className="h-36 w-36" src="https://cdn.ayahealthcare.com/marketingpublic/seattle_wa--200x200.png" alt="" />
                                        </div>
                                        <div className="text-xs flex flex-col gap-y-1">
                                            <span className="block font-semibold uppercase">
                                                Seattle, Washington
                                            </span>
                                            <div className="flex items-center gap-x-1">
                                                <BiPlusMedical className="text-lg" />
                                                <span className="block font-semibold">
                                                    Harborview Medical Center
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <MdOutlineCardTravel className="text-lg" />
                                                <span className="block">
                                                    Travel
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <CiStethoscope className="text-lg" />
                                                <span className="block">
                                                    ICU
                                                </span>
                                            </div>

                                            <div className="flex items-center gap-x-1">
                                                <AiOutlineClockCircle className="text-lg" />
                                                <span className="block">
                                                    4x12 Night
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <span className="text-lg font-semibold">
                                                    $
                                                </span>
                                                <span className="block">
                                                    $3476.59 to $3640.39 weekly
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <FiUsers className="text-lg" />
                                                <span className="block">
                                                    6 Openings
                                                </span>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="flex items-center gap-x-2">
                                        <div className="bg-cyan-100 w-fit px-2 py-1 rounded text-xs">
                                            New
                                        </div>
                                        <div className="flex items-center gap-x-1 bg-cyan-100 w-fit px-2 py-1 rounded">
                                            <AiOutlineStar className="text-gray-600 text-lg" />
                                            <p className="text-xs">Aya advantage</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-white p-3 rounded-lg" style={{
                                boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                            }}>
                                <div className="flex flex-col gap-y-1">
                                    <div className="flex gap-x-1 items-center">
                                        <span className="h-5 w-5 flex justify-center rounded-full items-center bg-red-600">
                                            <ImPower className="text-white text-sm" />
                                        </span>
                                        <span className="text-red-600 font-semibold">Crisis response
                                        </span>
                                    </div>
                                    <div className="flex items-start gap-x-2">
                                        <div>
                                            <img className="h-36 w-36" src="https://cdn.ayahealthcare.com/marketingpublic/seattle_wa--200x200.png" alt="" />
                                        </div>
                                        <div className="text-xs flex flex-col gap-y-1">
                                            <span className="block font-semibold uppercase">
                                                Seattle, Washington
                                            </span>
                                            <div className="flex items-center gap-x-1">
                                                <BiPlusMedical className="text-lg" />
                                                <span className="block font-semibold">
                                                    Harborview Medical Center
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <MdOutlineCardTravel className="text-lg" />
                                                <span className="block">
                                                    Travel
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <CiStethoscope className="text-lg" />
                                                <span className="block">
                                                    ICU
                                                </span>
                                            </div>

                                            <div className="flex items-center gap-x-1">
                                                <AiOutlineClockCircle className="text-lg" />
                                                <span className="block">
                                                    4x12 Night
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <span className="text-lg font-semibold">
                                                    $
                                                </span>
                                                <span className="block">
                                                    $3476.59 to $3640.39 weekly
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <FiUsers className="text-lg" />
                                                <span className="block">
                                                    6 Openings
                                                </span>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="flex items-center gap-x-2">
                                        <div className="bg-cyan-100 w-fit px-2 py-1 rounded text-xs">
                                            New
                                        </div>
                                        <div className="flex items-center gap-x-1 bg-cyan-100 w-fit px-2 py-1 rounded">
                                            <AiOutlineStar className="text-gray-600 text-lg" />
                                            <p className="text-xs">Aya advantage</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-white p-3 rounded-lg" style={{
                                boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                            }}>
                                <div className="flex flex-col gap-y-1">
                                    <div className="flex gap-x-1 items-center">
                                        <span className="h-5 w-5 flex justify-center rounded-full items-center bg-red-600">
                                            <ImPower className="text-white text-sm" />
                                        </span>
                                        <span className="text-red-600 font-semibold">Crisis response
                                        </span>
                                    </div>
                                    <div className="flex items-start gap-x-2">
                                        <div>
                                            <img className="h-36 w-36" src="https://cdn.ayahealthcare.com/marketingpublic/seattle_wa--200x200.png" alt="" />
                                        </div>
                                        <div className="text-xs flex flex-col gap-y-1">
                                            <span className="block font-semibold uppercase">
                                                Seattle, Washington
                                            </span>
                                            <div className="flex items-center gap-x-1">
                                                <BiPlusMedical className="text-lg" />
                                                <span className="block font-semibold">
                                                    Harborview Medical Center
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <MdOutlineCardTravel className="text-lg" />
                                                <span className="block">
                                                    Travel
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <CiStethoscope className="text-lg" />
                                                <span className="block">
                                                    ICU
                                                </span>
                                            </div>

                                            <div className="flex items-center gap-x-1">
                                                <AiOutlineClockCircle className="text-lg" />
                                                <span className="block">
                                                    4x12 Night
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <span className="text-lg font-semibold">
                                                    $
                                                </span>
                                                <span className="block">
                                                    $3476.59 to $3640.39 weekly
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <FiUsers className="text-lg" />
                                                <span className="block">
                                                    6 Openings
                                                </span>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="flex items-center gap-x-2">
                                        <div className="bg-cyan-100 w-fit px-2 py-1 rounded text-xs">
                                            New
                                        </div>
                                        <div className="flex items-center gap-x-1 bg-cyan-100 w-fit px-2 py-1 rounded">
                                            <AiOutlineStar className="text-gray-600 text-lg" />
                                            <p className="text-xs">Aya advantage</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>



                    <div className="lg:w-1/2 bg-white">
                        <div className="flex justify-end py-2 px-3">
                            <RxCross2 className="text-xl text-gray-500 font-semibold">
                            </RxCross2>
                        </div>
                        <div className="overflow-y-scroll p-4 h-[75vh] pb-10">
                            <div className="flex gap-x-2 border-b border-gray-400 pb-8">
                                <div>
                                    <img src="https://cdn.ayahealthcare.com/marketingpublic/seattle_wa--200x200.png" alt="" />
                                </div>
                                <div>
                                    <div className="flex gap-x-1">
                                        <button className="bg-cyan-100 rounded text-xs px-2 py-1">
                                            New
                                        </button>
                                        <div className="flex items-center gap-x-1 bg-cyan-100 w-fit px-2 py-1 rounded">
                                            <AiOutlineStar className="text-gray-600 text-lg" />
                                            <p className="text-xs">Aya advantage</p>
                                        </div>
                                    </div>
                                    <div className="flex gap-x-1 items-center">
                                        <span className="h-5 w-5 flex justify-center rounded-full items-center bg-red-600">
                                            <ImPower className="text-white text-sm" />
                                        </span>
                                        <span className="text-red-600 font-medium">Crisis response
                                        </span>
                                    </div>
                                    <div className="text-xs flex flex-col gap-y-2">
                                        <span className="block font-bold uppercase">
                                            Seattle, Washington
                                        </span>
                                        <div className="flex items-center gap-x-1">
                                            <BiPlusMedical className="text-lg" />
                                            <span className="block font-semibold">
                                                Harborview Medical Center
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <MdOutlineCardTravel className="text-lg" />
                                            <span className="block">
                                                Travel
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <CiStethoscope className="text-lg" />
                                            <span className="block">
                                                ICU
                                            </span>
                                        </div>

                                        <div className="flex items-center gap-x-1">
                                            <AiOutlineClockCircle className="text-lg" />
                                            <span className="block">
                                                4x12 Night
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <span className="text-lg font-semibold">
                                                $
                                            </span>
                                            <span className="block">
                                                $3476.59 to $3640.39 weekly
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <FiUsers className="text-lg" />
                                            <span className="block">
                                                6 Openings
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <BsCalendar2Check className="text-lg" />
                                            <span className="block">
                                                6/26/2023*
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <span>
                                                Job ID
                                            </span>
                                            <span className="block">
                                                2117052
                                            </span>
                                        </div>

                                        <p className="font-normal">
                                            *This info is approximate. Please confirm with your recruiter.
                                        </p>

                                        <div className="flex items-center gap-x-1 font-semibold">
                                            <BsFillShareFill />
                                            Share
                                        </div>

                                        <div>
                                            <button className="flex items-center gap-x-2 bg-cyan-400 py-2 px-3 rounded-full">
                                                <FaThumbsUp />
                                                <span className="uppercase font-medium">
                                                    I'm Interested
                                                </span>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="border-b border-gray-400 py-6">
                                <h1 className="font-bold">Qualifications</h1>
                                <div className="mt-3">
                                    <h2 className="font-semibold">Experience</h2>
                                    <ul className="list-inside list-disc px-3 text-sm">
                                        <li>
                                            MUST have 1.0 YEAR(S) experience
                                        </li>
                                        <li>
                                            Unit beds: 23
                                        </li>
                                        <li>
                                            Days: 4, Nights: 4
                                        </li>
                                    </ul>
                                </div>
                                <div className="mt-3">
                                    <h2 className="font-semibold">Requirements</h2>
                                    <ul className="list-inside list-disc px-3 text-sm">
                                        <li>
                                            Certifications: BCLS
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="border-b border-gray-400 py-6">
                                <h1 className="font-bold">About the Facility</h1>
                                <div className="flex gap-x-2">
                                    <button className="bg-gray-600 py-1 px-2 text-xs text-white rounded">
                                        Trauma - I
                                    </button>
                                    <button className="bg-gray-600 py-1 px-2 text-xs text-white rounded">
                                        Trauma - I
                                    </button>
                                    <button className="bg-gray-600 py-1 px-2 text-xs text-white rounded">
                                        Trauma - I
                                    </button>
                                    <button className="bg-gray-600 py-1 px-2 text-xs text-white rounded">
                                        Trauma - I
                                    </button>
                                </div>
                                <div className="flex flex-col text-[12px] mt-2">
                                    <div className="flex gap-x-2">
                                        <span className="font-semibold">Charting System</span>
                                        <span>
                                            Epic
                                        </span>
                                    </div>
                                    <div className="flex gap-x-2">
                                        <span className="font-semibold">Facility Beds</span>
                                        <span>
                                            332 beds
                                        </span>
                                    </div>
                                    <div className="flex items-center gap-x-2 mt-2">
                                        <a href="#" className="font-medium underline text-cyan-800">
                                            Learn more about this facility
                                        </a>
                                        <BsBoxArrowUpRight className="text-cyan-800 font-medium" />
                                    </div>
                                </div>
                            </div>

                            <div className="pt-8">
                                <h1 className="font-bold">
                                    Travel Happy with Aya Healthcare
                                </h1>
                                <div>
                                    <span className="font-semibold block text-sm py-2">
                                        Aya delivers :
                                    </span>

                                    <ul className="list-inside list-disc text-sm px-2">
                                        <li>
                                            <span className="font-semibold">
                                                The most jobs in the industry.
                                            </span>
                                            <span>
                                                We have the largest and most reliable job database, which means the jobs you see are open, updated in real time and ready for you!
                                            </span>
                                        </li>
                                        <li>
                                            <span className="font-semibold">
                                                Competitive advantage over other agencies.
                                            </span>
                                            <span>
                                                We have the largest and most reliable job database, which means the jobs you see are open, updated in real time and ready for you!
                                            </span>
                                        </li>
                                        <li>
                                            <span className="font-semibold">
                                                Expedited licensing and streamlined compliance.
                                            </span>
                                            <span>
                                                An industry-leading on-time start rate and strong relationships with boards of nursing across the country to accelerate the process in all 50 states.
                                            </span>
                                        </li>
                                        <li>
                                            <span className="font-semibold">
                                                Expert career guidance.
                                            </span>
                                            <span>
                                                A dedicated recruiter to help you achieve your dream career. Travel, per diem, permanent — we have the reach and access to get you the jobs you want, and the expertise to help you realize your long-term goals.
                                            </span>
                                        </li>
                                        <li>
                                            <span className="font-semibold">
                                                A best-in-class support system and an exceptional experience.
                                            </span>
                                            <span>
                                                Enjoy accurate, weekly pay, and an entire team dedicated to your happiness on assignment, 24/7.
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <span className="font-semibold block text-sm py-2">
                                        Plus, you get everything you expect from the largest healthcare staffing company in the industry:
                                    </span>

                                    <ul className="list-inside list-disc text-sm px-2">
                                        <li>
                                            <span>
                                                We have the largest and most reliable job database, which means the jobs you see are open, updated in real time and ready for you!
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                We have the largest and most reliable job database, which means the jobs you see are open, updated in real time and ready for you!
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                An industry-leading on-time start rate and strong relationships with boards of nursing across the country to accelerate the process in all 50 states.
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                A dedicated recruiter to help you achieve your dream career. Travel, per diem, permanent — we have the reach and access to get you the jobs you want, and the expertise to help you realize your long-term goals.
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                Enjoy accurate, weekly pay, and an entire team dedicated to your happiness on assignment, 24/7.
                                            </span>
                                        </li>
                                    </ul>
                                </div>

                                <p className="text-xs text-gray-500 italic mt-4">
                                    For all employees and employee applicants, Aya is an Equal Employment Opportunity ("EEO") Employer, including Disability/Vets, and welcomes all to apply. Please click here for our EEO policy.
                                </p>

                            </div>

                        </div>
                    </div>
                </div>

            </div>

            <Drawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} title="Filters">
                <div className="w-[300px]">
                    <h1 className="font-semibold mb-2">Filter by location</h1>
                    <Select
                        mode="multiple"
                        style={{
                            width: '100%',
                        }}
                        placeholder="City or State"
                        // defaultValue={locationSearch}
                        optionLabelProp="label"
                        value={locationSearch}
                        onChange={(e) => setLocationSearch(e)}
                    >

                        {
                            locationOptions?.map((val, i) => {
                                return (
                                    <Option key={i} value={val} label={val}>
                                        <Space>
                                            {val}
                                        </Space>
                                    </Option>
                                )
                            })
                        }
                    </Select>
                    <div className="bg-gray-200 p-3 mt-3">
                        <div className="flex items-center gap-x-2">
                            <input type="checkbox" name="" id="" />
                            <label htmlFor="">Compact License States</label>
                        </div>
                        <div>
                            <div className="flex items-center gap-x-2">
                                <input type="checkbox" name="" id="" />
                                <label htmlFor="">Quick License States</label>
                            </div>
                            <span className="font-semibold text-[12px]">Application process 2 weeks or less!</span>
                        </div>
                        <div className="flex justify-between gap-x-2 mt-2">
                            <AiOutlineInfoCircle className="text-[50px]" />
                            <p className="text-[12px]">
                                Many jobs don’t require a license in hand to apply. Your recruiter can
                                help plan for your ideal locations. We'll get you licensed quickly!
                            </p>
                        </div>
                    </div>
                    <button className="bg-cyan-400 px-3 py-1 font-semibold rounded-full mt-2">SHOW RESULTS</button>
                </div>
                <div className="w-[300px] my-5">
                    <h1 className="font-semibold mb-2">Filter by Specialities</h1>
                    <p className="text-[12px]">
                        You'll see specialties based on your profession of <a href="#" className="font-semibold">Registered Nurse Change</a>
                    </p>
                    <div className="mt-3">
                        <h1 className="font-semibold">Your specialities</h1>
                        <Select
                            mode="multiple"
                            style={{
                                width: '100%',
                            }}
                            placeholder="Specialities"
                            optionLabelProp="label"
                            value={specialitySearch}
                            onChange={(e) => setSpecialitySearch(e)}
                        >

                            {
                                specialityOptions?.map((val, i) => {
                                    return (
                                        <Option key={i} value={val} label={val}>
                                            <Space>
                                                {val}
                                            </Space>
                                        </Option>
                                    )
                                })
                            }
                        </Select>
                    </div>

                    <div>
                        {relatedSpecialityTags.length > 0 && <h2>Related Specialities</h2>}
                        <div className="p-2 flex gap-1 flex-wrap">
                            {
                                relatedSpecialityTags?.map((val, index) => {
                                    return (
                                        <Tag key={index} closable onClose={() => tagCloseSpeciality(val.key)}>
                                            {
                                                val.tag
                                            }
                                        </Tag>
                                    )
                                })
                            }
                        </div>
                    </div>

                    <div>
                        <div className="flex gap-x-2 items-center">
                            <input onChange={() => setIsLowerAcuity(!isLowerAcuity)} id="lower_aquity" type="checkbox" name="lower acuity specialities" />
                            <label htmlFor="lower_aquity">Include lower acuity specialties</label>
                        </div>
                        <div className="font-semibold mt-1">
                            {isLowerAcuity && <h1 className="mb-2">Lower Acuity</h1>}
                            <div className="flex gap-1 flex-wrap ">
                                {
                                    isLowerAcuity &&
                                    lowerAcuityTags?.map((val, index) => {
                                        return (
                                            <Tag key={index} closable onClose={() => tagCloseAcuity(val.key)}>
                                                {
                                                    val.tag
                                                }
                                            </Tag>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <button className="bg-cyan-400 px-3 py-1 font-semibold rounded-full mt-4 text-gray-700">SHOW RESULTS</button>
                </div>
                <div className="w-[300px]">
                    <h1 className="font-semibold text-gray-600 mb-2">Filter by Shifts & Contract</h1>
                    <div className="flex flex-col gap-y-3">
                        <div className="flex flex-col">
                            <div className="text-[#608d96] w-[100px]">
                                Employment Type
                            </div>
                            <div className="flex gap-2 items-center flex-wrap">
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    Travel
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    Per Diem
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    Permanent
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    Workforce Disruption
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    Interim Leadership
                                </label>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <div className="text-[#608d96] w-[100px]">
                                Contract Length <br />
                                (in weeks)
                            </div>
                            <div className="flex gap-2 items-center flex-wrap">
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    1 to 2 (Rapid Response)
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    3 to 6
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    7 to 10
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    11 to 16
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    17+
                                </label>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <div className="text-[#608d96] w-[100px]">
                                Shift
                            </div>
                            <div className="flex gap-2 items-center flex-wrap">
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    3x12
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    4x10
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    4x12
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    5x8
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    5x12
                                </label>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <div className="text-[#608d96] w-[100px]">
                                Time of Day
                            </div>
                            <div className="flex gap-2 items-center flex-wrap">
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    Day
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    Mid
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    Night
                                </label>
                            </div>
                        </div>
                        <div className="flex items-center gap-x-2 mt-2">
                            <div className="flex gap-2 items-center flex-wrap">
                                <label className="flex gap-x-1 items-center">
                                    <input type="checkbox" />
                                    Exclude Alternating Shifts
                                </label>
                            </div>
                        </div>
                        <div>
                            <button className="bg-cyan-400 px-3 py-1 font-semibold rounded-full mt-2">SHOW RESULTS</button>
                        </div>
                    </div>
                </div>
            </Drawer>

            <div className="fixed bottom-0 w-full">
                <Footer>
                </Footer>
            </div>

        </Navbar>
    )
}

export default SearchJobsPage